export enum Applications {
  aish = 'aish',
  intake = 'intake',
  case = 'case',
  caseload = 'caseload',
}
